import React from 'react';
import moment from 'moment';
import { ResultType } from '../../../enums/ResultType';
import { InternalCommunicationLog } from '../../../models/InternalCommunicationLog';
import { Container, CreatedAt, Message, State } from './styles';

interface ICardInternalCommunicationProps {
    communication: InternalCommunicationLog;
}

const CardInternalCommunication: React.FC<ICardInternalCommunicationProps> = ({
    communication
}) => {

    let stateDescription = "Comunicação pendente";
    if (communication.resultType === ResultType.Failed) stateDescription = "Comunicação com falha";
    if (communication.resultType === ResultType.Success) stateDescription = "Comunicação realizada com sucesso";

    return (
        <Container>
            <State>{stateDescription}</State>
            <CreatedAt>{moment(communication.createdAt).format('DD/MM/yyyy HH:mm:ss')}</CreatedAt>
            <Message>{communication.message}</Message>
        </Container>
    );
}

export {CardInternalCommunication};